module.exports = __webpack_public_path__ + "img/logo_anan.daa4b6c0.png";